import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import JobPostingsManager from './JobPostingsManager';

const AdminDashboard = () => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAdminSession = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
          withCredentials: true
        });
  
        console.log('[AdminDashboard] Auth check response:', res.data);
  
        if (res.data.isAuthenticated && res.data.user?.accountType === 'Admin') {
          setIsAuthorized(true);
        } else {
          toast.error('Unauthorized: Admin access only.');
          navigate('/admin/form/11');
        }
      } catch (err) {
        console.error('[AdminDashboard] Auth error:', err);
        toast.error('Failed to authenticate as admin.');
        navigate('/admin/form/11');
      } finally {
        setAuthChecked(true);
      }
    };
  
    checkAdminSession();
  }, [navigate]);
  

  if (!authChecked) return <p>Verifying Admin session...</p>;
  if (!isAuthorized) return null;

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Admin Dashboard</h1>
      <p>Welcome Admin! You can manage job postings and moderate forum activity here.</p>

      <div style={{ margin: '1rem 0' }}>
     <a href="/rpa" style={{ padding: '8px 12px', background: '#0d6efd', color: '#fff', borderRadius: 6, textDecoration: 'none' }}>
      Open RPA Dashboard
      </a>
      </div>
      <JobPostingsManager />
    </div>
  );
};

export default AdminDashboard;



// // src/components/AdminDashboard.js
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate, Link } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import JobPostingsManager from './JobPostingsManager';

// const AdminDashboard = () => {
//   const [authChecked, setAuthChecked] = useState(false);
//   const [isAuthorized, setIsAuthorized] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkAdminSession = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
//           withCredentials: true
//         });

//         if (res.data.isAuthenticated && res.data.user?.accountType === 'Admin') {
//           setIsAuthorized(true);
//         } else {
//           toast.error('Unauthorized: Admin access only.');
//           navigate('/admin/form/11');
//         }
//       } catch (err) {
//         console.error('[AdminDashboard] Auth error:', err);
//         toast.error('Failed to authenticate as admin.');
//         navigate('/admin/form/11');
//       } finally {
//         setAuthChecked(true);
//       }
//     };

//     checkAdminSession();
//   }, [navigate]);

//   if (!authChecked) return <p>Verifying Admin session...</p>;
//   if (!isAuthorized) return null;

//   return (
//     <div style={{ padding: '2rem' }}>
//       <h1>Admin Dashboard</h1>
//       <p>Welcome Admin! You can manage job postings and moderate forum activity here.</p>

//       {/* Quick link to RPA */}
//       <div style={{ margin: '1rem 0' }}>
//         <Link to="/rpa" style={{ padding: '0.5rem 0.75rem', border: '1px solid #333', borderRadius: 6 }}>
//           Go to RPA Dashboard
//         </Link>
//       </div>

//       <JobPostingsManager />
//     </div>
//   );
// };

// export default AdminDashboard;










// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';
// import JobPostingsManager from './JobPostingsManager';

// const AdminDashboard = () => {
//   const [authChecked, setAuthChecked] = useState(false);
//   const [isAuthorized, setIsAuthorized] = useState(false);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const checkAdminSession = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
//           withCredentials: true
//         });
  
//         console.log('[AdminDashboard] Auth check response:', res.data);
  
//         if (res.data.isAuthenticated && res.data.user?.accountType === 'Admin') {
//           setIsAuthorized(true);
//         } else {
//           toast.error('Unauthorized: Admin access only.');
//           navigate('/admin/form/11');
//         }
//       } catch (err) {
//         console.error('[AdminDashboard] Auth error:', err);
//         toast.error('Failed to authenticate as admin.');
//         navigate('/admin/form/11');
//       } finally {
//         setAuthChecked(true);
//       }
//     };
  
//     checkAdminSession();
//   }, [navigate]);
  

//   if (!authChecked) return <p>Verifying Admin session...</p>;
//   if (!isAuthorized) return null;

//   return (
//     <div style={{ padding: '2rem' }}>
//       <h1>Admin Dashboard</h1>
//       <p>Welcome Admin! You can manage job postings and moderate forum activity here.</p>
//       <JobPostingsManager />
//     </div>
//   );
// };

// export default AdminDashboard;



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import { toast } from 'react-toastify';

// const AdminDashboard = () => {
//   const [authChecked, setAuthChecked] = useState(false);
//   const [isAuthorized, setIsAuthorized] = useState(false);
//   const navigate = useNavigate();

//   // Single Auth Check for Admin on mount
//   useEffect(() => {
//     const checkAdminSession = async () => {
//       try {
//         const res = await axios.get(`${process.env.REACT_APP_API}/check/session`, {
//           withCredentials: true
//         });

//         if (res.data.isAuthenticated && res.data.user?.accountType === 'Admin') {
//           setIsAuthorized(true);
//         } else {
//           toast.error('Unauthorized: Admin access only.');
//           navigate('/admin/login');
//         }
//       } catch (err) {
//         console.error('[AdminDashboard] Auth error:', err);
//         toast.error('Failed to authenticate as admin.');
//         navigate('/admin/login');
//       } finally {
//         setAuthChecked(true);
//       }
//     };

//     checkAdminSession();
//   }, [navigate]);

//   if (!authChecked) return <p>Verifying Admin session...</p>;
//   if (!isAuthorized) return null;

//   return (
//     <div style={{ padding: '2rem' }}>
//       <h1>Admin Dashboard</h1>
//       <p>Welcome Admin! You can manage job postings and moderate forum activity here.</p>
//       {/* Admin tools like Post Job, Moderate Posts, etc. can be added here */}
//     </div>
//   );
// };

// export default AdminDashboard;











// import React from 'react';
// import { useNavigate } from 'react-router-dom';

// function AdminDashboard() {
//   const navigate = useNavigate();

//   const handleCreateJob = () => {
//     navigate('/admin/create-job');
//   };

//   const handleManageJobs = () => {
//     navigate('/admin/manage-jobs');
//   };

//   return (
//     <div style={{ padding: '2rem', textAlign: 'center' }}>
//       <h1 style={{ marginBottom: '1rem' }}>🛡️ Admin Dashboard - TJG Government Accounting</h1>

//       <p style={{ marginBottom: '2rem', color: '#555' }}>
//         Welcome to the Admin control panel. You can post new job openings, edit existing ones, and manage user activity here.
//       </p>

//       <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
//         <button
//           onClick={handleCreateJob}
//           style={{
//             backgroundColor: '#0a66c2',
//             color: 'white',
//             border: 'none',
//             padding: '0.8rem 1.5rem',
//             borderRadius: '8px',
//             fontSize: '1rem',
//             cursor: 'pointer',
//             width: '250px'
//           }}
//         >
//           ➕ Post New Job Opening
//         </button>

//         <button
//           onClick={handleManageJobs}
//           style={{
//             backgroundColor: '#17a2b8',
//             color: 'white',
//             border: 'none',
//             padding: '0.8rem 1.5rem',
//             borderRadius: '8px',
//             fontSize: '1rem',
//             cursor: 'pointer',
//             width: '250px'
//           }}
//         >
//           🛠️ Manage Existing Job Openings
//         </button>
//       </div>
//     </div>
//   );
// }

// export default AdminDashboard;
